import Vue from 'vue'
import App from './index.vue'
require('../../mock')

Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')

